module.exports = __webpack_public_path__ + "img/generic-feed-compress.6d6e07c4.png";